<template>
  <div class="color-picker-component">
    <div class="color-input-container">
      <b-colorpicker
        v-model="selectedColor"
        class="color-picker-btn"
        size="is-small"
        representation="square"
        horizontal-color-picker
      >
        <template #footer="{ color }">
          <div class="colorpicker-fields">
            <b-field grouped>
              <b-field horizontal label="R">
                <b-input
                  v-model.number="color.red"
                  type="number"
                  size="is-small"
                  aria-label="Rouge"
                  min="0"
                  max="255"
                />
              </b-field>
              <b-field horizontal label="G">
                <b-input
                  v-model.number="color.green"
                  type="number"
                  size="is-small"
                  aria-label="Vert"
                  min="0"
                  max="255"
                />
              </b-field>
              <b-field horizontal label="B">
                <b-input
                  v-model.number="color.blue"
                  type="number"
                  size="is-small"
                  aria-label="Bleu"
                  min="0"
                  max="255"
                />
              </b-field>
            </b-field>
            <b-field grouped>
              <b-field horizontal label="H">
                <b-input
                  v-model.number="color.hue"
                  type="number"
                  size="is-small"
                  aria-label="Teinte"
                  min="0"
                  max="359"
                  step="1"
                />
              </b-field>
              <b-field horizontal label="S">
                <b-input
                  type="number"
                  :value="Math.round(color.saturation * 100)"
                  size="is-small"
                  aria-label="Saturation"
                  min="0"
                  max="100"
                  step="1"
                  @input="color.saturation = $event / 100"
                />
              </b-field>
              <b-field horizontal label="L">
                <b-input
                  type="number"
                  :value="Math.round(color.lightness * 100)"
                  size="is-small"
                  aria-label="Luminosité "
                  min="0"
                  max="100"
                  step="1"
                  @input="color.lightness = $event / 100"
                />
              </b-field>
            </b-field>
          </div>
        </template>
      </b-colorpicker>
      <b-input
        v-model="selectedColor"
        icon-right="close-circle"
        icon-right-clickable
        @icon-right-click="resetColor"
      >
      </b-input>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { BInput, BField, BColorpicker } from "buefy"

export const DEFAULT_PICKER_COLOR = "#009acc" // Couleur par défaut

export default defineComponent({
  name: "ColorPicker",
  components: {
    BColorpicker,
    BField,
    BInput,
  },
  props: {
    modelValue: {
      type: String,
      required: false,
      default: "",
    },
  },

  emits: ["update:modelValue"],
  data() {
    return {
      selectedColor: DEFAULT_PICKER_COLOR,
    }
  },
  watch: {
    modelValue(): void {
      this.updateValue()
    },
    selectedColor(color: any | string): void {
      this.selectedColor = color + ""
      this.$emit("update:modelValue", this.selectedColor)
    },
  },
  mounted(): void {
    this.updateValue()
  },
  methods: {
    updateValue(): void {
      this.selectedColor = this.modelValue ? this.modelValue : ""
      this.$emit("update:modelValue", this.selectedColor)
    },

    updateSelectedColor(color: any | string): void {
      this.selectedColor = color + ""
      this.$emit("update:modelValue", this.selectedColor)
    },

    resetColor(): void {
      this.selectedColor = ""
    },
  },
})
</script>

<style lang="scss">
.color-input-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.color-picker-btn {
  cursor: pointer;
  margin-right: 5px;
}

.colorpicker .color-name {
  font-weight: bold;
  color: white;
}
</style>
